




































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { PartnerService } from "@/zh-website/src/views/partner/service";
import { RegService } from "@common/service/base-service/reg";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { HomeService } from "@/zh-website/src/views/Homes/service";
@Component({
  components: { SideBar, ReadTo }
})
export default class Apply extends Vue {
  active = 0;
  offsetTop = 968;

  activeEnd = false;
  isCollapse = true;
  radiosdf = "1";
  tname = "";
  temail = "";
  tbname = "";
  tbcomp = "";
  tbsi = "";
  tbtel = "";
  tbinf = "";
  mask = false;
  username = "";
  sex;
  nationality = "";
  city = "";
  year = "";
  phone = { val: "", err: false };
  email = { val: "", err: false };
  agree = false;
  validUpload = true;
  field = "";
  experienceUpload: any[] = [];
  rulecode="";
  codeImg = "";
  rulecodes="";
  experience = [
    {
      depName: "",
      position: "",
      responsibilities: "",
      durationTime: ""
    },
    {
      depName: "",
      position: "",
      responsibilities: "",
      durationTime: ""
    },
    {
      depName: "",
      position: "",
      responsibilities: "",
      durationTime: ""
    },
    {
      depName: "",
      position: "",
      responsibilities: "",
      durationTime: ""
    }
  ];
  educationUpload: any[] = [];
  education = [
    {
      startAndEndTime: "",
      institution: "",
      education: "",
      certificateName: "",
      showDeleteButtonContainer: false,
      showDeleteButton: false
    }
  ];
  isCheck = false;

  mounted() {
    this.username = "";
    this.sex = 1;
    this.nationality = "";
    this.city = "";
    this.year = "";
    this.getCode();
  }
  subInfo() {
    if (!this.isCheck) {
      this.$message.error("请仔细阅读并同意隐私协议");
      return;
    }
    // 验证 基础信息
    if (this.username == "") {
      return this.$message.error("请输入姓名");
    } else if (this.nationality == "") {
      return this.$message.error("请输入国籍/民族");
    } else if (this.city == "") {
      return this.$message.error("请输入现定居城市");
    } else if (this.year == "") {
      return this.$message.error("请输入出生日期");
    } else if (this.phone.val == "") {
      return this.$message.error("请输入手机号码");
    } else if (this.email.val == "") {
      return this.$message.error("请输入Email");
    }
   if(!this.rulecode) return this.$message.error("请输入验证码");
    // 验证 学历/专业资格
    this.educationUpload.length = 0;
    const haveFill = this.education.some(item => {
      return (
        item["startAndEndTime"] != "" &&
        item["institution"] != "" &&
        item["education"] != "" &&
        item["certificateName"] != ""
      );
    });
    const haveNoFill = this.education.some(item => {
      const str =
        item["startAndEndTime"] +
        item["institution"] +
        item["education"] +
        item["certificateName"];
      if (str.trim() != "") {
        if (
          item["startAndEndTime"] == "" ||
          item["institution"] == "" ||
          item["education"] == "" ||
          item["certificateName"] == ""
        ) {
          return true;
        }
      }
    });
    if (haveFill && !haveNoFill) {
      this.education.forEach(item => {
        if (item["startAndEndTime"].trim() != "") {
          this.educationUpload.push({
            startAndEndTime: item.startAndEndTime,
            institution: item.institution,
            educations: item.education,
            certificateName: item.certificateName
          });
        }
      });
    } else {
      return this.$message.error("学历/专业资格必须完整填写");
    }

    // 验证 主要工作经历
    this.experienceUpload.length = 0;
    const ehaveFill = this.experience.some(item => {
      return (
        item["depName"] != "" &&
        item["position"] != "" &&
        item["responsibilities"] != "" &&
        item["durationTime"] != ""
      );
    });
    const ehaveNoFill = this.experience.some(item => {
      const str =
        item["depName"] +
        item["position"] +
        item["responsibilities"] +
        item["durationTime"];
      if (str.trim() != "") {
        if (
          item["depName"] == "" ||
          item["position"] == "" ||
          item["responsibilities"] == "" ||
          item["durationTime"] == ""
        ) {
          return true;
        }
      }
    });
    if (ehaveFill && !ehaveNoFill) {
      this.experience.forEach(item => {
        if (item["depName"].trim() != "") {
          this.experienceUpload.push({
            depName: item.depName,
            position: item.position,
            responsibilities: item.responsibilities,
            durationTime: item.durationTime
          });
        }
      });
    } else {
      return this.$message.error("主要工作经历必须完整填写");
    }

    // 验证 专业领域
    if (this.field == "") {
      return this.$message.error("请输入专业领域");
    }

    // 提交
    const data = {
      name: this.username,
      nationality: this.nationality,
      sex: this.sex,
      city: this.city,
      phone: this.phone.val,
      email: this.email.val,
      birthday: this.year,
      educationList: this.educationUpload,
      workExperienceList: this.experienceUpload,
      area: this.field,
      code:this.rulecode,
      codeNum:this.rulecodes,
      signStatus:this.isCheck
    };
    PartnerService.addCooperationExpertApply(data).then((res: any) => {
      if (res.data) {
        this.$message.success(res.message);
        this.cleanForm();
        this.getCode();
      } else {
        this.$message.error(res.message);
      }
    });
  }
   //改变验证码
   changeCode() {
    this.getCode();
  }
  getCode() {
    HomeService.getCode().then(res => {
      this.codeImg = `data:image/png;base64,${res.data.code}`;
      this.rulecodes = res.data.codeNum;
    });
  }
  subInfo1() {
    if (this.agree) {
      this.checkUploadList();
      if (this.username == "") {
        this.$message.error("请输入姓名");
      } else if (this.nationality == "") {
        this.$message.error("请输入国籍/民族");
      } else if (this.city == "") {
        this.$message.error("请输入现定居城市");
      } else if (this.year == "") {
        this.$message.error("请输入出生日期");
      } else if (this.phone.val == "") {
        this.$message.error("请输入手机号码");
      } else if (this.email.val == "") {
        this.$message.error("请输入Email");
      } else if (this.educationUpload.length == 0) {
        this.$message.error("请输入学历/专业资格");
      } else if (this.experienceUpload.length == 0) {
        // this.$message.error("请输入主要工作经历");
      } else if (this.field == "") {
        this.$message.error("请输入专业领域");
      } else {
        const data = {
          name: this.username,
          nationality: this.nationality,
          sex: this.sex,
          city: this.city,
          phone: this.phone.val,
          email: this.email.val,
          birthday: this.year,
          educationList: this.educationUpload,
          workExperienceList: this.experienceUpload,
          area: this.field
        };
        if (this.validUpload) {
          PartnerService.addCooperationExpertApply(data).then((res: any) => {
            if (res.data) {
              this.$message.success(res.message);
              this.cleanForm();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }
    } else {
      this.$message.error("请勾选");
    }
  }
  cleanForm() {
    this.agree = false;
    this.username = "";
    this.nationality = "";
    this.city = "";
    this.phone.val = "";
    this.email.val = "";
    this.year = "";
    this.field = "";
    this.rulecode=""
    this.education = [
      {
        startAndEndTime: "",
        institution: "",
        education: "",
        certificateName: "",
        showDeleteButtonContainer: false,
        showDeleteButton: false
      }
    ];
    this.experience = [
      {
        depName: "",
        position: "",
        responsibilities: "",
        durationTime: ""
      },
      {
        depName: "",
        position: "",
        responsibilities: "",
        durationTime: ""
      },
      {
        depName: "",
        position: "",
        responsibilities: "",
        durationTime: ""
      },
      {
        depName: "",
        position: "",
        responsibilities: "",
        durationTime: ""
      }
    ];
  }
  checkUploadList() {
    //
    this.validUpload = true;
    this.educationUpload.length = 0;
    this.experienceUpload.length = 0;
    this.education.forEach((item: any) => {
      if (
        item["startAndEndTime"] == "" ||
        item["institution"] == "" ||
        item["education"] == "" ||
        (item["certificateName"] == "" && this.education.length != 1)
      ) {
        //
        // this.validUpload = false;
        // this.$message.error("学历/专业资格不能有空表格");
      } else if (item["startAndEndTime"] == "") {
        this.$message.error("请输入起止时间");
      } else if (item["institution"] == "") {
        this.$message.error("请输入毕业学校/发证机构");
      } else if (item["education"] == "") {
        this.$message.error("请输入学历");
      } else if (item["certificateName"] == "") {
        this.$message.error("请输入专业/证书名称");
      } else {
        this.educationUpload.push({
          startAndEndTime: item.startAndEndTime,
          institution: item.institution,
          educations: item.education,
          certificateName: item.certificateName
        });
      }
    });
    this.experience.forEach((item: any) => {
      if (
        item["depName"] == "" &&
        item["position"] == "" &&
        item["responsibilities"] == "" &&
        item["durationTime"] == ""
      ) {
        //
      } else if (
        item["depName"] != "" ||
        item["position"] != "" ||
        item["responsibilities"] != "" ||
        item["durationTime"] != ""
      ) {
        //
        if (item["depName"] == "") {
          this.$message.error("请输入部门名称");
          this.validUpload = false;
        } else if (item["position"] == "") {
          this.$message.error("请输入职位");
          this.validUpload = false;
        } else if (item["responsibilities"] == "") {
          this.$message.error("请输入工作职责");
          this.validUpload = false;
        } else if (item["durationTime"] == "") {
          this.$message.error("请输入时间");
          this.validUpload = false;
        } else {
          this.experienceUpload.push({
            depName: item.depName,
            position: item.position,
            responsibilities: item.responsibilities,
            durationTime: item.durationTime
          });
        }
      }
    });
  }
  add() {
    const arr = {
      startAndEndTime: "",
      institution: "",
      education: "",
      certificateName: "",
      showDeleteButtonContainer: false,
      showDeleteButton: false
    };
    this.education.push(arr);
  }
  showButtonContainer(index) {
    if (index < this.education.length) {
      this.education[index].showDeleteButtonContainer = true;
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
        // 当前设备是移动设备
        this.education[index].showDeleteButton = true;
      }
    }
  }
  hideButtonContainer(index) {
    if (index < this.education.length) {
      this.education[index].showDeleteButtonContainer = false;
      this.education[index].showDeleteButton = false;
    }
  }
  showDeleteButton(index) {
    //
    this.education[index].showDeleteButton = true;
  }
  deleteRow(index) {
    if (this.education.length > 1) this.education.splice(index, 1);
  }
  phoneTest() {
    const reg = RegService.PHONE;

    if (
      this.phone.val == "" ||
      this.phone.val.length <= 10 ||
      !reg.test(this.phone.val)
    ) {
      this.phone.err = true;
      this.$message.error("手机号码错误");
      this.phone.val = "";
      return false;
    } else {
      this.phone.err = false;
      return true;
    }
  }
  emailTest() {
    const regEmail = RegService.EMAIL;
    if (this.email.val != "" && !regEmail.test(this.email.val)) {
      this.$message.error("邮箱格式不正确");
      this.email.val = "";
    } else {
      this.email.err = false;
    }
  }
}
